import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CheckboxCard } from "./checkbox-card.model";

@Component({
  selector: "common-checkbox-cards",
  templateUrl: "./checkbox-cards.component.html",
  styleUrls: ["./checkbox-cards.component.scss"],
})
export class CheckboxCardsComponent {
  @Input() checkboxCards: CheckboxCard[];
  @Input() singleSelect: boolean = false;
  @Output() checkboxCardsChange = new EventEmitter<CheckboxCard[]>();

  constructor() {}

  checkBoxChange(event: Event) {
    const checkboxValue = (event.target as HTMLInputElement).value;
    const isChecked = (event.target as HTMLInputElement).checked;

    for (const checkboxCard of this.checkboxCards) {
      if (checkboxCard.value === checkboxValue) {
        checkboxCard.checked = isChecked;
      } else if (this.singleSelect && isChecked) {
        checkboxCard.checked = false;
      }
    }

    this.checkboxCardsChange.emit(this.checkboxCards);
  }
}
